var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { PropertyService } from './../api/property.service';
import { AgencyService } from './../api/agency.service';
import { ProjectService } from './../api/project.service';
import { OnInit, Injector } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PropertySearch } from '../models/index';
import { AbstractPropertiesSearch } from './shared/index';
import { Lightbox, LightboxConfig, LightboxEvent, LIGHTBOX_EVENT } from 'angular2-lightbox';
import { GoogleMapComponent } from '../gmaps/google-map/google-map.component';
var ProjectDetailsBaseComponent = /** @class */ (function (_super) {
    __extends(ProjectDetailsBaseComponent, _super);
    function ProjectDetailsBaseComponent(injector, route, agencyService, _lightbox, _lightboxEvent, _lighboxConfig, propertyService, projectService, window, document) {
        var _this = _super.call(this, injector, window) || this;
        _this.route = route;
        _this.agencyService = agencyService;
        _this._lightbox = _lightbox;
        _this._lightboxEvent = _lightboxEvent;
        _this._lighboxConfig = _lighboxConfig;
        _this.projectService = projectService;
        _this.window = window;
        _this.document = document;
        _this.type = 'project';
        _this.relatedProjects = [];
        return _this;
    }
    ProjectDetailsBaseComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.data.forEach(function (data) {
            _this.validateRouteDataParams(data, ['project']);
            if (data.project) {
                _this.item = data.project;
                _this.project = data.project;
                AbstractPropertiesSearch.propertySearch = new PropertySearch();
                AbstractPropertiesSearch.propertySearch.project_id = _this.project.id;
                _this.refreshProperties();
                _this.initLightbox(_this.project.images);
                var promise = _this.projectService.getProjects(_this.projectSearch, 1);
                if (promise) {
                    promise.then(function (projects) {
                        if (projects.length) {
                            _this.relatedProjects = projects.filter(function (e) { return e.id !== _this.project.id; });
                        }
                    });
                }
                _this.setTitle(_this.project.name);
                _this.setMetaDescription(_this.project.description);
            }
        });
    };
    ProjectDetailsBaseComponent.prototype.open = function (index) {
        var _this = this;
        if (this.window) {
            this._lighboxConfig.positionFromTop = 20;
        }
        this._subscription = this._lightboxEvent.lightboxEvent$.subscribe(function (event) { return _this._onReceivedEvent(event); });
        this._lightbox.open(this._albums, index, { wrapAround: true, showImageNumberLabel: true });
    };
    ProjectDetailsBaseComponent.prototype._onReceivedEvent = function (event) {
        if (event.id === LIGHTBOX_EVENT.CLOSE) {
            if (this._subscription) {
                this._subscription.unsubscribe();
            }
        }
    };
    ProjectDetailsBaseComponent.prototype.initLightbox = function (images) {
        this._albums = [];
        for (var _i = 0, images_1 = images; _i < images_1.length; _i++) {
            var image = images_1[_i];
            var album = {
                src: image.url,
                caption: image.description,
                thumb: image.width_560_url
            };
            this._albums.push(album);
        }
        this._lighboxConfig.fadeDuration = 1;
    };
    return ProjectDetailsBaseComponent;
}(AbstractPropertiesSearch));
export { ProjectDetailsBaseComponent };



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/project-details-base.component.ts.pre-build-optimizer.js